// Tempo de impressão em horas decimais, com no máximo 2 casas (1,1085457… -> 1,11).
// O tempo vem de segundos fracionados do fatiador ou de horas+minutos digitados
// (1h07 = 1,1166…), e gravar isso cru deixava campos como "1,1085457356770834"
// na aba Produtos/Pedidos. 0,01 h = 36 s: irrelevante pro custo (energia/desgaste).
// Valor que não é número (vazio, null) volta como veio — quem chama já trata.
export function arredondarHoras(valor) {
  const n = parseFloat(valor);
  return Number.isFinite(n) ? Math.round((n + Number.EPSILON) * 100) / 100 : valor;
}
